import React from "react";

const Footer = () => {

  return (
    <>
      <div className="container-fluid fixed-bottom" style={{ backgroundColor: "#343a40", padding: "10px", textAlign: "center" }}>
      &copy; 2021 - &nbsp;
          <strong>
            Developed by &nbsp;
            <a href="https://github.com/Excellent-Echo/ECHO-19">Echo-19</a>
          </strong>
      </div>
    </>
  )
}
export default Footer;